import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import { isLocalhost, getIdColegio } from "../../utils/utilerias"
import { loginValidationSchema } from "../../utils/validationSchemas"

import {
  Row,
  Col,
  CardBody,
  Card,
  UncontrolledAlert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import {
  useAuthStatus,
  useAuthUser,
  useAuthError,
  useAuthLoading,
  useAuthUserGmtOffset,
  useAuthIdColegio,
} from "../../store/auth/loginState/selectors.js"

// Formik formik
import { useFormik } from "formik"

// actions
import {
  authLoginUser,
  authSocialLogin,
  authSetIdColegio as authSetIdColegioAction,
} from "../../store/actions"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { isNumber } from "lodash"

const defaultConfig = {
  id_Colegio: -1,
  Nombre: "",
  Logo: "/logos/ual.svg",
  Color: "#003366",
  Textos: {
    Bienvenida: "Bienvenidos!",
    Instrucciones: "Ingresa tu correo institucional",
  },
}

const Login = props => {
  //meta title
  document.title = "Login | Campusvirtual"

  const [idColegio, setIdColegio] = useState(-1)
  const [config, setConfig] = useState(defaultConfig)

  const authStatus = useAuthStatus()
  const authUser = useAuthUser()
  const authError = useAuthError()
  const authLoading = useAuthLoading()
  const authUserGmtOffset = useAuthUserGmtOffset()
  //const idColegio = useAuthIdColegio()

  const colegiosOptions = [
    { value: -1, label: "Elige Colegio" },
    { value: 1, label: "Universidad America Latina" },
    { value: 3, label: "Ccepo" },
    { value: 10, label: "Uno Universidad" },
    { value: 6, label: "Iteg" },
    { value: 8, label: "Local Iteg" },
    { value: 11, label: "Montevideo" },
    { value: 5, label: "Local SIA" },
    { value: 17, label: "Local UNO" },
    { value: 15, label: "Local CCEPO" },
  ]

  // console.log("--------------")
  // console.log("authStatus:", authStatus)
  // console.log("authUser:", authUser)
  // console.log("authError:", authError)
  // console.log("authLoading:", authLoading)
  // console.log("authUserGmtOffset:", authUserGmtOffset)
  // console.log("idColegio:", idColegio)

  const dispatch = useDispatch()

  const formik = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // email: "edmundo.sanchez@gmail.com" || "",
      // password: "**********" || "",
      // id_colegio: idColegio,
      email: isLocalhost ? "soporte@campusvirtual.mx" : "",
      password: "",
      id_colegio: -1,
      rememberme: false,
    },
    validationSchema: loginValidationSchema,
    onSubmit: values => {
      let { password, rememberme, email, id_colegio } = values
      password = btoa(password) // Encriptar la contraseña antes de enviarla

      // Guardar datos en localStorage si está marcado "Remember Me"
      if (rememberme) {
        localStorage.setItem("loginForm", JSON.stringify({ email, id_colegio }))
      } else {
        localStorage.removeItem("loginForm")
      }
      dispatch(authSetIdColegioAction(id_colegio))
      dispatch(
        authLoginUser({ email, password, id_colegio }, props.router.navigate)
      )
    },
  })

  // Función para cargar los datos guardados en localStorage
  const loadStoredData = () => {
    try {
      const data = JSON.parse(localStorage.getItem("loginForm")) || null
      return data
    } catch (e) {
      console.warn("No se pudo acceder a localStorage:", e)
      return null
    }
  }

  // Cargar valores guardados en localStorage al montar el componente
  useEffect(() => {
    const storedData = loadStoredData()
    //console.debug("storedData", storedData)
    if (storedData) {
      formik.setFieldValue("email", storedData.email || "")
      formik.setFieldValue("id_colegio", storedData.id_colegio || -1)
      formik.setFieldValue("rememberme", true)
    }
  }, [])

  // useEffect(() => {
  //   if (idColegio > 0) {
  //     console.log("useEffect::idColegio", idColegio)
  //     formik.setFieldValue("id_colegio", idColegio)
  //     dispatch(authSetIdColegioAction(idColegio))
  //   }
  //   formik.setFieldValue("id_colegio", idColegio)
  // }, [dispatch, idColegio])

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const hostname = window.location.hostname
        const subdominio = hostname.includes(".")
          ? hostname.split(".")[0]
          : hostname.split(":")[0]
        const res = await fetch(
          `https://campusvirtualapi-beta.azurewebsites.net/api/configuracion/bydomain/${subdominio}`
        )
        const data = await res.json()
        console.log("data: ", data)
        setConfig(data)
      } catch (error) {
        console.error("Error cargando configuración:", error)
      }
    }

    fetchConfig()
  }, [])

  useEffect(() => {
    console.log("config:", config)
    const idColegioConfig = config?.id_Colegio
    console.log("idColegioConfig:", idColegioConfig)
    if (idColegioConfig > 0) {
      console.log("Entró idColegioConfig:", idColegioConfig)
      setIdColegio(idColegio)
      formik.setFieldValue("id_colegio", idColegio)
      dispatch(authSetIdColegioAction(idColegio))
    }
  }, [config["id_Colegio"]])

  const onDropdownChange = event => {
    //console.log(event)
    if (event) {
      dispatch(authSetIdColegioAction(event.value))
    }
  }

  const signInSocial = type => {
    dispatch(
      authSocialLogin(
        type,
        props.router.navigate,
        formik.values.id_colegio,
        new Date().getTimezoneOffset() / 60
      )
    )
  }

  //handleGoogleLoginResponse
  const googleResponse = response => {
    signInSocial(response, "google")
  }

  //handleFacebookLoginResponse
  const facebookResponse = response => {
    signInSocial(response, "facebook")
  }

  //for facebook and google authentication
  const socialResponse = type => {
    signInSocial(type)
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {config?.Textos?.Bienvenida || "Bienvenido!"}
                        </h5>
                        <p>Inicia sesión para continuar a Campusvirtual.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        formik.handleSubmit()
                        return false
                      }}
                    >
                      {authError ? (
                        <UncontrolledAlert color="danger">
                          {authError || "An error occurred"}
                        </UncontrolledAlert>
                      ) : null}

                      <div className="mb-2 ">
                        {config?.id_Colegio < 0 ? (
                          <React.Fragment>
                            <Label className="form-label">Colegio</Label>
                            <React.Fragment>
                              <Select
                                name="id_colegio"
                                id="id_colegio"
                                options={
                                  isLocalhost
                                    ? colegiosOptions
                                    : colegiosOptions.filter(
                                        college =>
                                          !college.label.includes("Local")
                                      )
                                }
                                onChange={option =>
                                  formik.setFieldValue(
                                    "id_colegio",
                                    option ? option.value : ""
                                  )
                                } // Aquí está la corrección
                                onBlur={() =>
                                  formik.setFieldTouched("id_colegio", true)
                                }
                                value={colegiosOptions.find(
                                  option =>
                                    option.value === formik.values.id_colegio
                                )}
                                placeholder="Selecciona tu colegio..."
                              ></Select>
                            </React.Fragment>
                          </React.Fragment>
                        ) : (
                          <></>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Correo Electrónico</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          autoComplete="off"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email || ""}
                          invalid={
                            formik.touched.email && formik.errors.email
                              ? true
                              : false
                          }
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <FormFeedback type="invalid">
                            {formik.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Contraseña</Label>
                        <Input
                          name="password"
                          value={formik.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          autoComplete="off"
                          invalid={
                            formik.touched.password && formik.errors.password
                              ? true
                              : false
                          }
                        />
                        {formik.touched.password && formik.errors.password ? (
                          <FormFeedback type="invalid">
                            {formik.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="rememberme"
                          id="rememberme"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.rememberme}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberme"
                        >
                          Recuerdame
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className={"btn btn-primary btn-block"}
                          type="submit"
                          disabled={!formik.isValid || authLoading}
                        >
                          {authLoading ? (
                            <>
                              <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                            </>
                          ) : null}
                          Accesar
                        </button>
                      </div>

                      {formik.values.id_colegio > 0 ? (
                        <>
                          <div className="mt-4 text-center">
                            <h5 className="font-size-14 mb-3">
                              Inicia Sesión con...
                            </h5>

                            <ul className="list-inline">
                              {/*<li className="list-inline-item">*/}
                              {/*  <TwitterLogin*/}
                              {/*    loginUrl={*/}
                              {/*      "http://localhost:4000/api/v1/auth/twitter"*/}
                              {/*    }*/}
                              {/*    onSuccess={this.twitterResponse}*/}
                              {/*    onFailure={this.onFailure}*/}
                              {/*    requestTokenUrl={*/}
                              {/*      "http://localhost:4000/api/v1/auth/twitter/revers"*/}
                              {/*    }*/}
                              {/*    showIcon={false}*/}
                              {/*    tag={"div"}*/}
                              {/*  >*/}
                              {/*    <a*/}
                              {/*      href=""*/}
                              {/*      className="social-list-item bg-info text-white border-info"*/}
                              {/*    >*/}
                              {/*      <i className="mdi mdi-twitter"/>*/}
                              {/*    </a>*/}
                              {/*  </TwitterLogin>*/}
                              {/*</li>*/}
                              <li className="list-inline-item">
                                <Link
                                  to="#"
                                  className="social-list-item bg-danger text-white border-danger"
                                  onClick={e => {
                                    e.preventDefault()
                                    socialResponse("google")
                                  }}
                                >
                                  <i className="mdi mdi-google" />
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </>
                      ) : null}

                      <div className="mt-4 text-center">
                        {/* <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Olvidaste tu contraseña?
                        </Link> */}
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                {/* <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p> */}
                <p>
                  © {new Date().getFullYear()} CampusVirtual. Creado con{" "}
                  <i className="mdi mdi-heart text-danger" /> por Campusvirtual
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
